import { FamilyHistory } from '../types/patientHistory'
import { MaskedField } from './MaskedField'
import './FamilyHistoryList.css'

interface FamilyHistoryListProps {
  familyHistory: FamilyHistory[]
  patientId?: string
  onEdit: (entry: FamilyHistory) => void
  onDelete: (entryId: string) => Promise<void>
}

export function FamilyHistoryList({ familyHistory, patientId, onEdit, onDelete }: FamilyHistoryListProps) {
  return (
    <MaskedField
      field="family-history"
      value={familyHistory}
      patientId={patientId}
      confidentialityLevel="restricted"
    >
      {(canAccess, maskedFamilyHistory, requestEmergencyAccess) => {
        if (!canAccess) {
          return (
            <div className="family-history-empty">
              <p>You do not have permission to view family history.</p>
              {requestEmergencyAccess && (
                <button
                  onClick={requestEmergencyAccess}
                  className="btn-secondary btn-small"
                  style={{ marginTop: '1rem' }}
                >
                  Request Emergency Access
                </button>
              )}
            </div>
          )
        }

        if (maskedFamilyHistory.length === 0) {
          return (
            <div className="family-history-empty">
              <p>No family history recorded yet.</p>
            </div>
          )
        }

        return (
          <div className="family-history-list">
      {maskedFamilyHistory.map((entry: FamilyHistory) => (
        <div key={entry.id} className={`family-history-item ${entry.isPertinent ? 'pertinent' : ''}`}>
          <div className="family-history-header">
            <div className="family-history-title">
              <h3>{entry.relationship}</h3>
              {entry.isPertinent && (
                <span className="badge badge-pertinent">Pertinent</span>
              )}
            </div>
            <div className="family-history-actions">
              <button
                className="btn-link"
                onClick={() => onEdit(entry)}
              >
                Edit
              </button>
              <button
                className="btn-link btn-danger"
                onClick={() => {
                  if (window.confirm(`Delete family history entry for ${entry.relationship}?`)) {
                    onDelete(entry.id)
                  }
                }}
              >
                Delete
              </button>
            </div>
          </div>

          <div className="family-history-details">
            <div className="family-history-condition">
              <strong>Condition:</strong> {entry.condition}
            </div>
            {entry.ageAtDiagnosis !== undefined && (
              <div className="family-history-detail">
                <strong>Age at Diagnosis:</strong> {entry.ageAtDiagnosis} years
              </div>
            )}
            {entry.ageAtDeath !== undefined && (
              <div className="family-history-detail">
                <strong>Age at Death:</strong> {entry.ageAtDeath} years
              </div>
            )}
            {entry.causeOfDeath && (
              <div className="family-history-detail">
                <strong>Cause of Death:</strong> {entry.causeOfDeath}
              </div>
            )}
            {entry.recordedBy && (
              <div className="family-history-detail">
                <strong>Recorded by:</strong> {entry.recordedBy}
              </div>
            )}
          </div>

          {entry.notes && (
            <div className="family-history-notes">
              <strong>Notes:</strong> {entry.notes}
            </div>
          )}
        </div>
      ))}
    </div>
        )
      }}
    </MaskedField>
  )
}
